import React from 'react';
import PropTypes from 'prop-types';
import ZeroPaymentIcon from '../../../../common/img/components/ZeroPaymentIcon';

const ZeroPaymentBox = ({ copy }) => {
  return (
    <div className="zero-payment-required-wrapper">
      <ZeroPaymentIcon />
      <div className="zero-payment-copy">{ copy }</div>
    </div>
  );
};

ZeroPaymentBox.propTypes = {
  copy: PropTypes.string.isRequired,
};

export default ZeroPaymentBox;
